"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hotkeys = exports.SHORTCUT_TYPE = void 0;

var _noop = _interopRequireDefault(require("lodash/noop"));

var _constants = require("./constants");

var _autolinker = require("../../utils/autolinker");

var _utils = require("../../utils");

var SHORTCUT_TYPE = {
  add: 'add',
  remove: 'remove'
};
exports.SHORTCUT_TYPE = SHORTCUT_TYPE;
var Hotkeys = {
  Strikethrough: {
    pattern: 'meta+shift+X',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      return editor.execCommand('Strikethrough');
    }
  },
  Indent: {
    pattern: 'meta+221',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      return editor.execCommand('Indent');
    }
  },
  Outdent: {
    pattern: 'meta+219',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      return editor.execCommand('Outdent');
    }
  },
  BulletedList: {
    pattern: 'meta+shift+8',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      var selection = editor.dom.getParents(editor.selection.getNode());
      var isBulletedList = selection.some(function (node) {
        return node === 'ul';
      });
      editor.execCommand('RemoveList');

      if (!isBulletedList) {
        editor.execCommand('InsertUnorderedList');
      }
    }
  },
  NumberedList: {
    pattern: 'meta+shift+7',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      var selection = editor.dom.getParents(editor.selection.getNode());
      var isNumberedList = selection.some(function (node) {
        return node === 'ol';
      });
      editor.execCommand('RemoveList');

      if (!isNumberedList) {
        editor.execCommand('InsertOrderedList');
      }
    }
  },
  RemoveFormat: {
    pattern: 'meta+220',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      if (editor.selection.isCollapsed()) {
        return;
      }

      editor.execCommand('RemoveFormat');
    }
  },
  IncreaseFontSize: {
    pattern: 'meta+shift+187',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      var node = editor.selection.getNode();
      var currentFontSize = editor.dom.getStyle(node, 'font-size', true);

      if (currentFontSize === '32px') {
        return;
      }

      var currFontSizeIndex = _constants.SIZES.indexOf(currentFontSize !== null && currentFontSize !== void 0 ? currentFontSize : '13px');

      var newFontSize = _constants.SIZES[currFontSizeIndex + 1];
      editor.execCommand('FontSize', false, newFontSize);
    }
  },
  DecreaseFontSize: {
    pattern: 'meta+shift+189',
    type: SHORTCUT_TYPE.add,
    command: function command(editor) {
      var node = editor.selection.getNode();
      var currentFontSize = editor.dom.getStyle(node, 'font-size', true);

      if (currentFontSize === '10px') {
        return;
      }

      var currFontSizeIndex = _constants.SIZES.indexOf(currentFontSize !== null && currentFontSize !== void 0 ? currentFontSize : '13px');

      var newFontSize = _constants.SIZES[currFontSizeIndex - 1];
      editor.execCommand('FontSize', false, newFontSize);
    }
  },
  Link: {
    pattern: 'meta+k',
    type: SHORTCUT_TYPE.add,
    command: function command(editor, linkDialogRef) {
      if (editor.selection.isCollapsed()) {
        linkDialogRef.current.show();
      } else {
        var content = editor.selection.getContent();
        var div = document.createElement('div');
        div.innerHTML = content;
        var text = div.innerText.trim();

        if (text) {
          if ((0, _utils.isURL)(text)) {
            editor.execCommand('mceInsertLink', false, text);
            return true;
          }

          try {
            var url = (0, _autolinker.formatUrl)(text);
            linkDialogRef.current.show(text, url);
          } catch (e) {
            linkDialogRef.current.show(text);
          }
        } else {
          linkDialogRef.current.show();
        }
      }

      return false;
    }
  },
  Header1: {
    pattern: 'access+1',
    type: SHORTCUT_TYPE.remove
  },
  Header2: {
    pattern: 'access+2',
    type: SHORTCUT_TYPE.remove
  },
  Header3: {
    pattern: 'access+3',
    type: SHORTCUT_TYPE.remove
  },
  Header4: {
    pattern: 'access+4',
    type: SHORTCUT_TYPE.remove
  },
  Header5: {
    pattern: 'access+5',
    type: SHORTCUT_TYPE.remove
  },
  Header6: {
    pattern: 'access+6',
    type: SHORTCUT_TYPE.remove
  },
  Paragraph: {
    pattern: 'access+7',
    type: SHORTCUT_TYPE.remove
  },
  Div: {
    pattern: 'access+8',
    type: SHORTCUT_TYPE.remove
  },
  Address: {
    pattern: 'access+9',
    type: SHORTCUT_TYPE.remove
  },
  FocusToMenuBar: {
    pattern: 'alt+120',
    type: SHORTCUT_TYPE.remove
  },
  FocusToToolbar: {
    pattern: 'alt+121',
    type: SHORTCUT_TYPE.remove
  },
  FocusToElementPath: {
    pattern: 'alt+122',
    // remove does not work
    type: SHORTCUT_TYPE.add,
    command: function command() {
      return _noop["default"];
    }
  },
  FocusToContextualToolbar: {
    pattern: 'ctrl+120',
    // remove does not work
    type: SHORTCUT_TYPE.add,
    command: function command() {
      return _noop["default"];
    }
  }
};
exports.Hotkeys = Hotkeys;
//# sourceMappingURL=hotkey.js.map